module.exports = __webpack_public_path__ + "img/tuxsuite-build.971bc453.svg";